import { useQuery } from '@tanstack/react-query';
import type { ChatbotPrompt, DisplayLocation } from '@repo/types';
import { SECTIONS, DOMAINS, IMPORTANCE } from '@repo/monitoring';
import { API } from 'api';
import { apiBasePath, apiName } from 'assets';

const fetchChatbotPrompts = async (
  location: DisplayLocation,
): Promise<ChatbotPrompt[]> => {
  const response: { result: ChatbotPrompt[] } = await API.get(
    apiName,
    `${apiBasePath}/v1/chatbot-prompts?location=${location}`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.RESULTS,
        domain: DOMAINS.CONTENT,
        importance: IMPORTANCE.MEDIUM,
      },
      context: {
        displayLocation: location,
      },
    },
  );
  return response?.result ?? [];
};

export const useChatbotPrompts = (location: DisplayLocation | null) => {
  return useQuery({
    queryKey: ['chatbotPrompts', location],
    queryFn: () => fetchChatbotPrompts(location!),
    enabled: !!location,
    staleTime: 5 * 60 * 1000,
  });
};
